import React from 'react'
import PropTypes from 'prop-types'
import cx from 'classnames'
import RefreshIndicator from 'material-ui/RefreshIndicator'
import Waypoint from 'react-waypoint'
import BookingPatientRow from './BookingPatientRow'
import SortDirectionArrow from '../../PatientGroups/PatientList/Header/SortDirectionArrow'
import css from '../../sitewide/ScheduleBox/styles.css'
import styles from './styles.css'

const BookingPatientsList = ({
  allPatientsLoaded,
  bookingPatients,
  changeSort,
  fetchAdditionalPatients,
  loading,
  openDialog,
  sortColumn,
  sortDirection,
}) => {
  const columns = [
    'first_name',
    'last_name',
    'guardian_name',
    'phone',
    'email',
    'attribution',
    'created_at',
  ]
  const headerCellStyles = col =>
    cx(
      css.headerCell,
      css.cell,
      styles.headerCell,
      styles[`${col}HeaderCell`],
    )
  const fillerText = loading
    ? 'Loading Online Scheduling Patients...'
    : 'No Online Scheduling Patients Found'

  return (
    <div className={css.wrapper}>
      <ul className={css.header}>
        <li className={css.headerRow}>
          {columns.map((col) => {
            const activeColumn = col === sortColumn
            return (
              <div
                className={headerCellStyles(col)}
                key={col}
                id={col}
                onClick={changeSort}
              >
                {col === 'attribution'
                  ? 'referred by'
                  : col.split('_').join(' ')}
                {activeColumn && (
                  <SortDirectionArrow asc={sortDirection === 'asc'} />
                )}
              </div>
            )
          })}
        </li>
      </ul>
      {bookingPatients.length ? (
        <div className={styles.listWrapper}>
          <ul className={css.body}>
            {bookingPatients.map(patient => (
              <BookingPatientRow
                key={patient.id}
                patient={patient}
                openDialog={openDialog}
              />
            ))}
          </ul>
          <div>
            {!allPatientsLoaded && (
              <Waypoint onEnter={fetchAdditionalPatients} />
            )}
          </div>
          <div className={styles.loader}>
            <RefreshIndicator
              size={50}
              top={-15}
              left={0}
              status={loading ? 'loading' : 'hide'}
              color="#1B78B3"
            />
          </div>
        </div>
      ) : (
        <div className={styles.noPatientsFound}>{fillerText}</div>
      )}
    </div>
  )
}

BookingPatientsList.propTypes = {
  allPatientsLoaded: PropTypes.bool.isRequired,
  bookingPatients: PropTypes.arrayOf(PropTypes.object).isRequired,
  changeSort: PropTypes.func.isRequired,
  fetchAdditionalPatients: PropTypes.func.isRequired,
  openDialog: PropTypes.func.isRequired,
  loading: PropTypes.bool.isRequired,
  sortColumn: PropTypes.string.isRequired,
  sortDirection: PropTypes.string.isRequired,
}

export default BookingPatientsList



// WEBPACK FOOTER //
// ./src/components/OnlineScheduling/BookingPatients/BookingPatientsList.js